import { useCallback, useMemo } from 'react';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';

// provides a stable handleClose function for analytics in the storage hard limits modal entrypoint
const useStorageHardLimitsModalOnCloseOld = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClose = useCallback(() => {
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'closed',
				actionSubject: 'modal',
			}),
			'storageHardLimitsModal',
		);
	}, [createAnalyticsEvent]);

	return { handleClose };
};

const useStorageHardLimitsModalOnCloseNew = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useMemo(
		() => ({
			handleClose() {
				fireUIAnalytics(
					createAnalyticsEvent({
						action: 'closed',
						actionSubject: 'modal',
					}),
					'storageHardLimitsModal',
				);
			},
		}),
		[createAnalyticsEvent],
	);
};

export const useStorageHardLimitsModalOnClose = functionWithCondition(
	() => fg('jfp-magma-perf-nextgenboard-refactor'),
	useStorageHardLimitsModalOnCloseNew,
	useStorageHardLimitsModalOnCloseOld,
);
